
export default {
  name: 'mobile-menu-button',
  methods: {
    toggleMenu() {
      const showMenu = this.$store.getters['layout/showMobileMenu'];
      this.$store.dispatch('layout/toggleMenu', !showMenu);
    },
  },
};
